import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const items = ['Complete Natural Remedies Encyclopedia (PDF, 120+ pages, 200+ recipes)', 'Symptom Matrix Grid (30-second remedy finder)', 'Dosage Calculator (family-adjusted dosing)', '3 Prep Methods Per Remedy (tea/tincture/topical)', '7-Day Gut Cleanse Protocol', '30-Day Energy Challenge', 'Printable Wallet Card (emergency remedies)'];
export function WhatYouGet() {
  return <section className="py-20 bg-[#faf8f0]" data-id="element-206">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-207">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-208">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a3c2a] mb-6" data-id="element-209">
            Everything Inside Your Encyclopedia
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-210">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-white p-6 rounded-xl shadow-sm border border-[#1a3c2a]/10 flex items-start gap-4" data-id="element-211">
              <CheckCircle className="w-6 h-6 text-[#1a3c2a] shrink-0 mt-0.5" data-id="element-212" />
              <span className="text-[#5c4a32] font-medium text-lg" data-id="element-213">{item}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}